import { FC, PropsWithChildren } from 'react'

import './DraggableCalendarItem.scss'

interface DraggableCalendarItemProps extends PropsWithChildren {
    isDisabled?: boolean;
    id: string;
    onClick: (id: string) => void;
    onStartDrag: (id: string) => void;
    className?: string;
}

const DraggableCalendarItem: FC<DraggableCalendarItemProps> = ({
    isDisabled,
    children,
    id,
    onClick,
    onStartDrag,
    className = '',
}) => {
    const handleClick = () => {
        onClick(id)
    }

    const handleStartDrag = () => {
        onStartDrag(id)
    }

    return (
        <button
            type="button"
            disabled={isDisabled}
            onClick={handleClick}
            draggable={! isDisabled}
            onDragStart={handleStartDrag}
            className={`draggable-calendar-item ${className}`}
        >
            {children}
        </button>
    )
}

export default DraggableCalendarItem
